import React, { useState, useEffect } from "react";
import { Modal, Table, Button, Grid } from "antd";
import AddB2BClientLocationModal from "./AddB2BClientLocationModal";

const { useBreakpoint } = Grid;

const ManageB2BClientAddressesModal = ({ open, onClose, client }) => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addEditVisible, setAddEditVisible] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const screens = useBreakpoint();
  const isMobile = !screens.md;

  useEffect(() => {
    if (client) {
      setLocations(client.b2b_locations || []);
      setLoading(false);
    }
  }, [client]);

  const handleAddEditSuccess = () => {
    setLocations([...client.b2b_locations]);
    setAddEditVisible(false);
    setSelectedLocation(null);
  };

  const columns = [
    {
      title: "Address Identifier",
      dataIndex: ["location", "address_identifier"],
      render: (text) => text || "--",
      ellipsis: true,
    },
    {
      title: "Apartment / Road / Area",
      dataIndex: ["location", "apartment_road_area"],
      render: (text) => text || "--",
      responsive: ["sm"],
      ellipsis: true,
    },
    {
      title: "House / Flat / Floor",
      dataIndex: ["location", "house_flat_floor_no"],
      render: (text) => text || "--",
      responsive: ["md"],
    },
    {
      title: "Status",
      dataIndex: ["location", "status"],
      render: (status) => (
        <span style={{ color: status === "enable" ? "green" : "red" }}>
          {status === "enable" ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      title: "Action",
      render: (_, record) => (
        <Button
          size="small"
          onClick={() => {
            setSelectedLocation(record.location);
            setAddEditVisible(true);
          }}
        >
          Edit
        </Button>
      ),
    },
  ];

  // Mobile card view for locations
  const MobileLocationCard = ({ record }) => (
    <div
      style={{
        border: "1px solid #f0f0f0",
        borderRadius: 8,
        padding: "10px 12px",
        marginBottom: 10,
        background: "#fff",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
        <div style={{ fontWeight: 600, fontSize: 14 }}>
          {record.location?.address_identifier || "--"}
        </div>
        <span style={{ color: record.location?.status === "enable" ? "green" : "red", fontSize: 12 }}>
          {record.location?.status === "enable" ? "Active" : "Inactive"}
        </span>
      </div>
      <div style={{ fontSize: 12, color: "#666", marginBottom: 2 }}>
        {record.location?.apartment_road_area || "--"}
      </div>
      <div style={{ fontSize: 12, color: "#888", marginBottom: 8 }}>
        {record.location?.house_flat_floor_no || "--"}
      </div>
      <Button
        size="small"
        onClick={() => {
          setSelectedLocation(record.location);
          setAddEditVisible(true);
        }}
      >
        Edit
      </Button>
    </div>
  );

  return (
    <>
      <Modal
        title={`Manage Addresses — ${client.name}`}
        open={open}
        onCancel={onClose}
        footer={null}
        width={isMobile ? "100%" : 800}
        style={isMobile ? { top: 0, margin: 0, maxWidth: "100vw", padding: 0 } : {}}
        bodyStyle={isMobile ? { padding: "12px 8px" } : {}}
      >
        <Button
          type="primary"
          size={isMobile ? "small" : "middle"}
          style={{ marginBottom: 16 }}
          onClick={() => setAddEditVisible(true)}
        >
          Add Address
        </Button>

        {isMobile ? (
          <div>
            {locations.length === 0 ? (
              <div style={{ textAlign: "center", color: "#aaa", padding: "32px 0" }}>No addresses found</div>
            ) : (
              locations.map((record) => (
                <MobileLocationCard key={record.id} record={record} />
              ))
            )}
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <Table
              rowKey={(record) => record.id}
              columns={columns}
              dataSource={locations}
              loading={loading}
              pagination={{ pageSize: 5, size: "small" }}
              scroll={{ x: "max-content" }}
            />
          </div>
        )}
      </Modal>

      {addEditVisible && (
        <AddB2BClientLocationModal
          open={addEditVisible}
          onClose={() => {
            setAddEditVisible(false);
            setSelectedLocation(null);
          }}
          onSuccess={handleAddEditSuccess}
          b2bClientId={client.id}
          initialValues={selectedLocation ? { location: selectedLocation } : null}
          locationId={selectedLocation?.id}
        />
      )}
    </>
  );
};

export default ManageB2BClientAddressesModal;